import { IonIcon } from '@ionic/react';
import { send } from 'ionicons/icons';
import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import ReactMarkdown from 'react-markdown';

import { UiTypography } from '@/components/ui/Typography';

import styles from './AnswerButton.module.scss';

export const AnswerButtonList: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <div className={styles['answer-button-list']}>{children}</div>;
};

export const AnswerButton: React.FC<{
  text: string;
  onClick: () => void;
  show?: boolean;
}> = ({ text, onClick, show = true }) => {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = !shouldReduceMotion;

  if (canAnimate) {
    return (
      <AnimatePresence>
        {show && (
          <motion.div
            className={styles['answer-button']}
            onClick={onClick}
            aria-label="Chat button"
            role="button"
            variants={{
              initial: {
                transform: 'translateY(100%)',
                opacity: 0,
                scale: 0,
              },
              animate: {
                transform: 'translateY(0)',
                opacity: 1,
                scale: 1,
              },
              exit: {
                transform: 'translateY(100%)',
                opacity: 0,
                scale: 0,
              },
            }}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <Content text={text} />
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return (
    <div
      className={styles['answer-button']}
      onClick={onClick}
      aria-label="Chat button"
      role="button"
    >
      <Content text={text} />
    </div>
  );
};

function Content({ text }: { text: string }) {
  return (
    <>
      <UiTypography
        className={styles.text}
        variant="body-medium"
        color="white-static"
        component="span"
      >
        <ReactMarkdown
          components={{
            p: 'span',
            em(props) {
              const { node, ...rest } = props;
              return <i style={{ color: '#ffffff80' }} {...rest} />;
            },
          }}
        >
          {text}
        </ReactMarkdown>
      </UiTypography>

      <button
        className={styles['send-button']}
        type="button"
        aria-label="Send message"
      >
        <IonIcon icon={send} />
      </button>
    </>
  );
}
